import markdown from '@/../RELEASE_NOTES.md'
import markdownComponents from '@/components/MarkDownComponents'
import { releaseNotesRootRoute } from '@/router/rootRoutes'
import { createRoute } from '@tanstack/react-router'
import ReactMarkdown from 'react-markdown'

export const releaseNotesRoute = createRoute({
  getParentRoute: () => releaseNotesRootRoute,
  path: '/',
  component: () => <ReleaseNotes />,
})

export function ReleaseNotes() {
  return (
    <ReactMarkdown components={markdownComponents}>{markdown}</ReactMarkdown>
  )
}
